import React from "react";
import DataGridFooterComponent from "./components/data-grid-footer.component";
import { Card } from "reactstrap";
import DataGridHeaderComponent from "./components/data-grid-header.component";
import ListComponent from "@atoms/list/list.component";
import FeatherIcon from "feather-icons-react";
import ToolTipComponent from "@atoms/tooltip/tooltip.component";
import { PRIMARY_KEY } from "@constants/app.constants";
import ModalComponent from "@atoms/modal/modal.component";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import DataGridManageColumnsComponent from "./components/data-grid-manage-columns.component";
import SpinnerComponent from "@atoms/spinner/spinner.component";

const DataGridMobileTemplate = ({
  templateModal: {
    title,
    selected,
    filters,
    tableControls,
    openFilterMenu,
    page,
    totalCount,
    rowsPerPage,
    swapContent,
    tableData,
    tableColumn,
    tableActions,
    editFormData,
    openDeleteDialog,
    loading,
    showManageColumns,
    tableParams,
  },
  templateEvents: {
    handlePagination,
    handleChangeRowsPerPage,
    handleDownload,
    handleFilterSubmit,
    handleDeleteRecords,
    handleFilterIconClick,
    handleManageColumnsClick,
    handleEditClick,
    handleBadgeClick,
    handleCheckBoxClick,
    handleModalEditSubmitTrigger,
    handleModalEditCancel,
    handleModalEditSubmit,
    confirmDeleteData,
    cancelDeleteData,
    isSelected,
  },
}) => {
  return (
    <>
      <Card>
        <DataGridHeaderComponent
          title={title}
          selected={selected}
          filters={filters}
          tableControls={tableControls}
          openFilterMenu={openFilterMenu}
          handleDownload={handleDownload}
          handleFilterSubmit={handleFilterSubmit}
          handleDeleteRecords={handleDeleteRecords}
          handleFilterIconClick={handleFilterIconClick}
          handleManageColumnsClick={handleManageColumnsClick}
        />

        {loading && (
          <SpinnerComponent
            styles={{ marginTop: 1, textAlign: "center" }}
            spinnerStyles={{ textAlign: "center" }}
          />
        )}

        {!swapContent && (
          <>
            <div>
              {tableData &&
                tableData.map((row) => {
                  const items = tableColumn.map((column) => {
                    let value;

                    if (column.isBadge) {
                      value = (
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            column.badgeClick
                              ? handleBadgeClick({
                                  action: column.badgeClick,
                                  primaryKeyValue: row[PRIMARY_KEY],
                                  currentValue: row[column.id],
                                })
                              : null
                          }
                        >
                          <span
                            className={`badge bg-${
                              column.badgeColor[row[column.id]]
                            }`}
                          >
                            {column.badgeText[row[column.id]]}
                          </span>
                        </a>
                      );
                    }

                    if (!column.isBadge) {
                      value = (
                        <>
                          {column.formatData
                            ? column.formatData(row[column.id],row)
                            : row[column.id]}
                        </>
                      );
                    }

                    return {
                      key: column.label,
                      value: value,
                    };
                  });

                  let buttons;
                  if (tableActions && tableActions.length > 0)
                    buttons = tableActions.map((action) => {
                      return (
                        <>
                          <ToolTipComponent content={action.name}>
                            <button
                              id={`${action.name || action.id}-${
                                row[PRIMARY_KEY]
                              }`}
                              style={{ marginRight: 5, padding: 5 }}
                              className={
                                action.buttonClass
                                  ? action.buttonClass
                                  : "btn btn-primary btn-sm"
                              }
                              onClick={() => action.onClick(row)}
                            >
                              <FeatherIcon icon={action.icon} size={15} />
                            </button>
                          </ToolTipComponent>
                        </>
                      );
                    });

                  const isItemSelected = isSelected(row[PRIMARY_KEY]);

                  const checkBox = (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isItemSelected}
                      onClick={(e) => handleCheckBoxClick(e, row[PRIMARY_KEY])}
                    />
                  );

                  items.push({
                    key: checkBox,
                    value: (
                      <>
                        {buttons && <> {buttons} </>}
                        <button
                          style={{ padding: 5 }}
                          className="btn btn-primary btn-sm"
                          onClick={(event) => handleEditClick(event, row)}
                        >
                          <FeatherIcon icon="edit" size={15} />
                        </button>
                      </>
                    ),
                  });

                  console.log({ items });

                  return <ListComponent items={items} type="KEY_VALUE" />;
                })}
            </div>
          </>
        )}

        {swapContent && <>{swapContent}</>}

        <DataGridFooterComponent
          page={page}
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          handlePagination={handlePagination}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />

        <ModalComponent
          open={editFormData.open}
          title={"Edit " + title}
          primaryText={"Submit"}
          secondaryText={"Cancel"}
          primaryAction={handleModalEditSubmitTrigger}
          secondaryAction={handleModalEditCancel}
        >
          <FormBuilderComponent
            formType="default"
            inputFields={editFormData.formInputs}
            submitTrigger={editFormData.submitTrigger}
            onSubmit={handleModalEditSubmit}
          />
        </ModalComponent>

        <ModalComponent
          open={openDeleteDialog}
          title={"Delete !"}
          message={"Are you sure to delete the selected entries"}
          primaryText={"Delete"}
          secondaryText={"Cancel"}
          primaryAction={confirmDeleteData}
          secondaryAction={cancelDeleteData}
        />

        <DataGridManageColumnsComponent
          open={showManageColumns}
          tableColumn={tableColumn}
          tableParams={tableParams}
          toggleClick={handleManageColumnsClick}
        />
      </Card>
    </>
  );
};

export default DataGridMobileTemplate;
